'use client';

import { useSyncExternalStore } from 'react';

function subscribe(callback: () => void) {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener('popstate', callback);
  return () => window.removeEventListener('popstate', callback);
}

function getSnapshot(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const hasEmbedQuery = urlParams.get('embed') === 'true';
    const isIframe = window.self !== window.top;
    return hasEmbedQuery || isIframe;
  } catch {
    return false;
  }
}

function getServerSnapshot(): boolean {
  return false;
}

/**
 * Hook to detect whether current page is being viewed in embed widget mode.
 * Returns true if ?embed=true is in query string or inside an iframe.
 */
export function useIsEmbed(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
